/* eslint-disable no-underscore-dangle */
const { define, requirejs } = require('requirejs');

const { pageContextProps: pageContext, authorizations } = window._webpack_init_props;
pageContext.authorizations = authorizations;
delete window._webpack_init_props.pageContextProps;
delete window._webpack_init_props.authorizations;

define('PageContext', pageContext);

requirejs(['PageContext']);

module.exports = pageContext;
